export default {
      id: "uniform-distribution-usage",
      viewBox: "0 0 32 32",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#uniform-distribution-usage",
      toString: function () {
        return this.url;
      }
    }